import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import OtherPosts from './OtherPosts';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import GenerateInternalLinks from './GenerateInternalLinks';

function PostDetail({ blogs }) {
  const { selected_post_slug } = useParams();
  const navigate = useNavigate();

  const [selectedSupportingArticles, setSelectedSupportingArticles] = useState([]);

  const [remainingPosts, setRemainingPosts] = useState([]);

  const getSlugFromUrl = (url) => {
    const parts = url.split('/').filter(Boolean);
    return parts[parts.length - 1];
  };

  const selectedPost = blogs.find((post) => getSlugFromUrl(post.url) === selected_post_slug);

  useEffect(() => {
    if (selectedPost) {
      const filteredPosts = blogs.filter((post) => post !== selectedPost).map(post => ({ ...post, linkSuggestions: [], newContents: [] }));
      setRemainingPosts(filteredPosts);
    }
  }, [blogs, selectedPost]);

  const toggleSupportingArticle = (url) => {
    setSelectedSupportingArticles((prevSelected) => {
      if (prevSelected.includes(url)) {
        return prevSelected.filter((item) => item !== url);
      } else {
        return [...prevSelected, url];
      }
    });
  };

  const updatePostNewContents = (url, newContent, deleteIndex = null) => {
    setRemainingPosts((prevPosts) => {
      return prevPosts.map((post) => {
        if (post.url === url) {
          let updatedNewContents = post.newContents ? [...post.newContents] : [];
          if (deleteIndex !== null) {
            updatedNewContents.splice(deleteIndex, 1);
          } else if (newContent) {
            updatedNewContents.push(newContent);
          }
          return { ...post, newContents: updatedNewContents };
        }
        return post;
      });
    });
  };

  const supportingArticlesForGenerate = selectedSupportingArticles.length > 0 ? selectedSupportingArticles : remainingPosts.map(post => post.url);

  if (!selectedPost) {
    return (
      <div className="p-6">
        <MdOutlineKeyboardBackspace
          size={25}
          className="cursor-pointer mb-2"
          onClick={() => navigate(-1)}
          title="Back"
          aria-label="Back"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate(-1); }}
        />
        <p className="mt-4">Post not found.</p>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-6">
      <MdOutlineKeyboardBackspace
        size={25}
        className="mb-2 cursor-pointer"
        onClick={() => navigate(-1)}
        title="Back"
        aria-label="Back"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate(-1); }}
      />
      <div className="flex gap-6">
        <div className="w-2/3 border p-4 rounded overflow-auto max-h-screen">
          <GenerateInternalLinks
            defaultTargetUrl={selectedPost.url}
            defaultSupportingArticles={supportingArticlesForGenerate}
            remainingPosts={remainingPosts}
            setRemainingPosts={setRemainingPosts}
          />
          {selectedPost.featured_media_url && (
            <img
              src={selectedPost.featured_media_url}
              alt={selectedPost.title}
              className="mb-4 w-full h-auto object-cover rounded"
            />
          )}
          <h2 className="text-2xl font-bold mb-4">{selectedPost.title}</h2>
          <div className="prose" dangerouslySetInnerHTML={{ __html: selectedPost.content || 'No content available.' }} />
        </div>
        <div className="w-1/3 border p-4 rounded overflow-auto max-h-screen">
          <h3 className="text-xl font-semibold mb-4">Other Posts ({remainingPosts.length})</h3>
          <OtherPosts
            targetUrl={selectedPost.url}
            posts={remainingPosts}
            selectedSupportingArticles={selectedSupportingArticles}
            toggleSupportingArticle={toggleSupportingArticle}
            remainingPosts={remainingPosts}
            setRemainingPosts={setRemainingPosts}
          />
        </div>
      </div>
    </div>
  );
}


export default PostDetail;
